import { reactive } from 'vue';
import { defaultsDeep, mapValues } from '../_';
import touch from './touch.json';
import masks from './masks.json';
import screens from './screens.json';
import theme from './theme';
import locales from './locales';

const pluginDefaults = {
  componentPrefix: 'v',
  navVisibility: 'click',
  titlePosition: 'center',
  transition: 'slide-h',
  touch,
  masks,
  screens,
  theme,
  locales,
  datePicker: {
    updateOnInput: true,
    inputDebounce: 1000,
    popover: {
      visibility: 'hover-focus',
      placement: 'bottom-start',
      keepVisibleOnInput: false,
    },
  },
};

const defaultsState = reactive({
  defaults: null,
  locales: {},
});

const buildLocales = defaults =>
  mapValues(defaults.locales, localeConfig => {
    const locale = { ...localeConfig };
    locale.masks = defaultsDeep({}, locale.masks, defaults.masks);
    return locale;
  });

export const setupDefaults = (opts = {}) => {
  if (!defaultsState.defaults) {
    defaultsState.defaults = defaultsDeep({}, opts, pluginDefaults);
    defaultsState.locales = buildLocales(defaultsState.defaults);
  }
  return defaultsState.defaults;
};

export const defaultsMixin = {
  beforeCreate() {
    setupDefaults();
  },
  computed: {
    $defaults() {
      return defaultsState.defaults;
    },
    $locales() {
      return defaultsState.locales;
    },
  },
};
